module.exports = "/_next/static/images/Coins-072ea9f83a157bc001c3641a31f09692.png";